module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var i18n = require(\'@cdo/netsim/locale\');\n%>\n<div class="content-wrap">\n  <div class="field-box display-name-control">\n    <label for="netsim-lobby-name"><%= i18n.myName() %></label>\n    <input id="netsim-lobby-name" type="text" value="<%= displayName %>" <% if (displayName.length > 0) { %>disabled<% } %> />\n    <% if (displayName.length === 0) { %>\n      <input id="netsim-lobby-set-name-button" type="button" value="<%= i18n.setName() %>" disabled />\n    <% } %>\n  </div>\n  <% if (displayName.length > 0) { %>\n    <div class="field-box shard-control">\n      <label for="netsim-shard-select"><%= i18n.mySection() %></label>\n      <select id="netsim-shard-select" <% if (selectedShardID) { %>disabled<% } %>>\n        <option value="<%= SELECTOR_NONE_VALUE %>"><%= i18n.dropdownPickOne() %></option>\n        <%\n          var selectedAnyShard = false;\n          shardChoices.forEach(function (shardChoice) {\n            var attributes = \'\';\n            if (shardChoice.shardID === selectedShardID) {\n              attributes = \'selected\';\n              selectedAnyShard = true;\n            }\n            %>\n              <option value="<%= shardChoice.shardID %>" <%= attributes %>><%= shardChoice.displayName %></option>\n            <%\n          });\n        %>\n      </select>\n      <% if (!selectedShardID) { %>\n        <input id="netsim-shard-confirm-button" type="button" value="<%= i18n.joinSection() %>" <% if (!selectedAnyShard) { %>disabled<% } %> />\n      <% } %>\n    </div>\n  <% } %>\n\n  <div class="lobby-hint">\n    <i class="fa fa-info-circle" aria-hidden="true"></i>\n    <% if (displayName.length === 0) { %>\n      <p>\n        You\'re not currently signed in. If you are trying to use the simulator\n        with your class, please <a href="/users/sign_in">sign in</a> and then return\n        to this page.\n      </p>\n    <% } else { %>\n      <p>\n        It looks like you are a member of more than one class section.  To make\n        sure you can connect to your classmates, please use the dropdown\n        above to select the class section that is currently doing the\n        Internet Simulator activity, then click "<%= i18n.joinSection() %>" to\n        proceed.\n      </p>\n    <% } %>\n  </div>\n\n  <div class="clearfix"></div>\n</div>\n', __filename = "src/netsim/NetSimShardSelectionPanel.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("@cdo/netsim/locale");
            __line = 3;
            __append('\n<div class="content-wrap">\n  <div class="field-box display-name-control">\n    <label for="netsim-lobby-name">');
            __line = 6;
            __append(escapeFn(i18n.myName()));
            __append('</label>\n    <input id="netsim-lobby-name" type="text" value="');
            __line = 7;
            __append(escapeFn(displayName));
            __append('" ');
            if (displayName.length > 0) {
                __append("disabled");
            }
            __append(" />\n    ");
            __line = 8;
            if (displayName.length === 0) {
                __append('\n      <input id="netsim-lobby-set-name-button" type="button" value="');
                __line = 9;
                __append(escapeFn(i18n.setName()));
                __append('" disabled />\n    ');
                __line = 10;
            }
            __append("\n  </div>\n  ");
            __line = 12;
            if (displayName.length > 0) {
                __append('\n    <div class="field-box shard-control">\n      <label for="netsim-shard-select">');
                __line = 14;
                __append(escapeFn(i18n.mySection()));
                __append('</label>\n      <select id="netsim-shard-select" ');
                __line = 15;
                if (selectedShardID) {
                    __append("disabled");
                }
                __append('>\n        <option value="');
                __line = 16;
                __append(escapeFn(SELECTOR_NONE_VALUE));
                __append('">');
                __append(escapeFn(i18n.dropdownPickOne()));
                __append("</option>\n        ");
                __line = 17;
                var selectedAnyShard = false;
                shardChoices.forEach(function(shardChoice) {
                    var attributes = "";
                    if (shardChoice.shardID === selectedShardID) {
                        attributes = "selected";
                        selectedAnyShard = true;
                    }
                    __line = 25;
                    __append('\n              <option value="');
                    __line = 26;
                    __append(escapeFn(shardChoice.shardID));
                    __append('" ');
                    __append(escapeFn(attributes));
                    __append(">");
                    __append(escapeFn(shardChoice.displayName));
                    __append("</option>\n            ");
                    __line = 27;
                });
                __line = 29;
                __append("\n      </select>\n      ");
                __line = 31;
                if (!selectedShardID) {
                    __append('\n        <input id="netsim-shard-confirm-button" type="button" value="');
                    __line = 32;
                    __append(escapeFn(i18n.joinSection()));
                    __append('" ');
                    if (!selectedAnyShard) {
                        __append("disabled");
                    }
                    __append(" />\n      ");
                    __line = 33;
                }
                __append("\n    </div>\n  ");
                __line = 35;
            }
            __append('\n\n  <div class="lobby-hint">\n    <i class="fa fa-info-circle" aria-hidden="true"></i>\n    ');
            __line = 39;
            if (displayName.length === 0) {
                __append('\n      <p>\n        You\'re not currently signed in. If you are trying to use the simulator\n        with your class, please <a href="/users/sign_in">sign in</a> and then return\n        to this page.\n      </p>\n    ');
                __line = 45;
            } else {
                __append('\n      <p>\n        It looks like you are a member of more than one class section.  To make\n        sure you can connect to your classmates, please use the dropdown\n        above to select the class section that is currently doing the\n        Internet Simulator activity, then click "');
                __line = 50;
                __append(escapeFn(i18n.joinSection()));
                __append('" to\n        proceed.\n      </p>\n    ');
                __line = 53;
            }
            __append('\n  </div>\n\n  <div class="clearfix"></div>\n</div>\n');
            __line = 58;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}